import { Outlet } from "react-router-dom";
import Layout from "../../layout/Layout";

const Expenses = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default Expenses;
